import { useDispatch, useSelector } from 'react-redux';

import { selectIsEmailValidated, selectIsEmailVerificationNotificationClosed } from 'helpers/selectors';
import { closeEmailVerificationNotification } from 'actions/app';

/**
 * Hook for managing email verification banner visibility and interactions.
 *
 * @returns {Object} Banner state and controls
 * @returns {boolean} returns.shouldShowBanner - Whether to display the banner
 * @returns {Function} returns.closeBanner - Function to close/dismiss the banner
 *
 * @example
 * const { shouldShowBanner, closeBanner } = useEmailVerificationBanner();
 *
 * return shouldShowBanner && (
 *   <EmailVerificationBanner onClose={closeBanner} />
 * );
 */
export const useEmailVerificationBanner = () => {
    const dispatch = useDispatch();
    const isNotificationClosed = useSelector(selectIsEmailVerificationNotificationClosed);
    const isEmailVerified = useSelector(selectIsEmailValidated);

    return {
        shouldShowBanner: !isEmailVerified && !isNotificationClosed,
        closeBanner: () => dispatch(closeEmailVerificationNotification),
    };
};
